module.exports = __webpack_public_path__ + "media/images/favicon-32x32-0b457f1a9df8e82553134b0d1c7bf905.png";